var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.orderModalData.open
        ? _c("sideBarOrderModal", {
            attrs: {
              modalData: _vm.orderModalData,
              onModalClose: _vm.closeOrderModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData
        ? _c(
            "EmptyCardModal",
            {
              ref: "emptyModal",
              attrs: {
                onModalClose: _vm.closeModal,
                onModalAccept: _vm.updatePhoneRecord,
                modalData: _vm.modalData,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modalData.comment,
                          expression: "modalData.comment",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        placeholder: "Комментарий к звонку",
                        type: "text",
                      },
                      domProps: { value: _vm.modalData.comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.modalData,
                            "comment",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modalData.hideRecord,
                          expression: "modalData.hideRecord",
                        },
                      ],
                      attrs: { type: "checkbox", id: "ch_1" },
                      domProps: {
                        checked: Array.isArray(_vm.modalData.hideRecord)
                          ? _vm._i(_vm.modalData.hideRecord, null) > -1
                          : _vm.modalData.hideRecord,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.modalData.hideRecord,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.modalData,
                                  "hideRecord",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.modalData,
                                  "hideRecord",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.modalData, "hideRecord", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "pointer", attrs: { for: "ch_1" } },
                      [_vm._v("Скрыть звонок")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.modalData.message
                    ? _c("div", { staticClass: "alert alert-info" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.modalData.message) +
                            "\n      "
                        ),
                      ])
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _vm.loading
              ? _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: { loading: _vm.loading, color: _vm.loadingColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "text-right p-b-10" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-success",
                    on: { click: _vm.getMissedCalls },
                  },
                  [_vm._v("\n            Обновить\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "table table-hover table-sm" }, [
                _vm._m(1),
                _vm._v(" "),
                !_vm.loading
                  ? _c(
                      "tbody",
                      _vm._l(_vm.records, function (record, phone, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _c("p", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(
                              "\n              " +
                                _vm._s(record.id) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              record.type_id === 3
                                ? [
                                    _c("p", [
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-dark" },
                                        [_vm._v("Звонок создан на сайте")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$AllProjects[
                                                record.data?.site_id
                                              ]?.title
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("p", [
                                      _vm._v(_vm._s(record.phone_title)),
                                    ]),
                                  ],
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-muted created_ago_missed_calls",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.printDate(
                                        record.created_at,
                                        "DD.MM.YYYY HH:mm"
                                      )
                                    ) + "\n                "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-info p-0" },
                                    [
                                      _c("time-ago", {
                                        attrs: {
                                          refresh: "",
                                          datetime: record.created_at,
                                          locale: "ru",
                                          long: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", [
                            record.client
                              ? _c("div", [
                                  _c("p", [_vm._v(_vm._s(record.client.name))]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "\n                  зарегистрирован: " +
                                        _vm._s(
                                          _vm.printDate(
                                            record.client.created_at,
                                            "DD.MM.YYYY HH:mm"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.blackList[record.phone_title]
                                    ? _c(
                                        "div",
                                        [
                                          _vm._m(2, true),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                    добавлен: " +
                                                  _vm._s(
                                                    _vm.printDate(
                                                      _vm.blackList[
                                                        record.phone_title
                                                      ].created_at,
                                                      "DD.MM.YYYY HH:mm"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.blackList[record.phone_title]
                                              .comments,
                                            function (comment) {
                                              return _c(
                                                "div",
                                                { key: comment.created_at },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(comment.text)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-muted",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            comment.user_name
                                                          ) +
                                                          " - " +
                                                          _vm._s(
                                                            _vm.printDate(
                                                              comment.created_at,
                                                              "DD.MM.YYYY HH:mm"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.client.orders
                                    ? _c(
                                        "div",
                                        { staticClass: "flex flex-wrap" },
                                        _vm._l(
                                          record.client.orders,
                                          function (order) {
                                            return _c(
                                              "div",
                                              {
                                                key: order.id,
                                                staticClass: "order_block",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    (" +
                                                    _vm._s(
                                                      _vm.$AllProjects[
                                                        order.site_id
                                                      ].name
                                                    ) +
                                                    ")\n                    " +
                                                    _vm._s(order.id) +
                                                    " (" +
                                                    _vm._s(
                                                      (_vm.$AllCities[
                                                        order.city_id
                                                      ] &&
                                                        _vm.$AllCities[
                                                          order.city_id
                                                        ].short_name) ||
                                                        "Почтовая"
                                                    ) +
                                                    ")\n                    "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-success",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.statuses[
                                                          order.status
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-info newWindowBtn mr-1",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openOrderInModal(
                                                          order.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-eye",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                order.status < 0
                                                  ? [
                                                      _c("i", {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value: {
                                                              placement:
                                                                "bottom-center",
                                                              content:
                                                                order.reject_comment,
                                                            },
                                                            expression:
                                                              "{\n                          placement: 'bottom-center',\n                          content: order.reject_comment\n                        }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "comment_tooltip_fa icon-fa icon-fa-info-circle it-has-a-tooltip",
                                                      }),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("div", [
                                _c("p", [_vm._v(_vm._s(record.destination))]),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      record.ip_phone &&
                                        record.ip_phone.description
                                    ) + "\n                  "
                                  ),
                                ]),
                                record.type_id === 3 && record.black_list
                                  ? _c(
                                      "div",
                                      [
                                        _vm._m(3, true),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "text-muted" }, [
                                          _vm._v(
                                            "\n                      добавлен: " +
                                              _vm._s(
                                                _vm.printDate(
                                                  record.black_list.created_at,
                                                  "DD.MM.YYYY HH:mm"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          record.black_list.comments,
                                          function (comment) {
                                            return _c(
                                              "div",
                                              { key: comment.created_at },
                                              [
                                                _c("p", [
                                                  _vm._v(_vm._s(comment.text)),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          comment.user_name
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.printDate(
                                                            comment.created_at,
                                                            "DD.MM.YYYY HH:mm"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p"),
                              ]),
                              _vm._v(" "),
                              record.extra_calls && record.extra_calls.length
                                ? _vm._l(
                                    record.extra_calls,
                                    function (exCall, ind1) {
                                      return _c("div", { key: ind1 }, [
                                        _c("p", [
                                          _vm._v(_vm._s(exCall.destination)),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "text-muted" }, [
                                          _vm._v(
                                            _vm._s(
                                              record.ip_phone &&
                                                record.ip_phone.description
                                            ) + "\n                    "
                                          ),
                                        ]),
                                      ])
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _vm.callBack[record.phone_title]
                                ? _vm._l(
                                    _vm.callBack[record.phone_title],
                                    function (call, ind) {
                                      return _c("div", { key: ind }, [
                                        _c("p", [
                                          _vm._v(
                                            "\n                    (" +
                                              _vm._s(call.user_id) +
                                              ":" +
                                              _vm._s(call.id) +
                                              ")\n                    " +
                                              _vm._s(
                                                call.user && call.user.name
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(call.phone_title)),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "text-muted" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.printDate(
                                                call.created_at,
                                                "DD.MM.YYYY HH:mm"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        !call.showRecord && call.file_link
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-success btn-xs",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    call.showRecord = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Показать запись звонка\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        call.showRecord
                                          ? _c("div", [
                                              call.audio_record_id
                                                ? _c(
                                                    "audio",
                                                    { attrs: { controls: "" } },
                                                    [
                                                      _c("source", {
                                                        attrs: {
                                                          src: `https://admin.rancond.info/api/noa/mangoRecord/${call.id}`,
                                                          type: "audio/mpeg",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                      Your browser does not support the audio tag.\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                      ])
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(
                              record?.data?.notified_users ?? [],
                              function (u) {
                                return _c(
                                  "span",
                                  { staticClass: "badge badge-dark mr-1" },
                                  [
                                    _vm._v(
                                      _vm._s(u.user_name) +
                                        " (" +
                                        _vm._s(u.user_id) +
                                        ")"
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _vm._l(record.comments, function (comment, ind) {
                                return _c("div", { key: ind }, [
                                  _c("p", [_vm._v(_vm._s(comment.comment))]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(comment.user_name) +
                                        " (" +
                                        _vm._s(
                                          _vm.printDate(
                                            comment.created_at,
                                            "DD.MM.YYYY HH:mm",
                                            null,
                                            0
                                          )
                                        ) +
                                        ")\n                "
                                    ),
                                  ]),
                                ])
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-xs btn-info",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCommentModal(record)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Редактировать\n              "
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              record.type_id === 3
                                ? [
                                    _c("LoadingButton", {
                                      attrs: {
                                        title:
                                          '<i class="icon-fa icon-fa-phone-square"></i>',
                                        type: "button",
                                        loading: _vm.btnsLoading[record.id],
                                        color: "white",
                                        onClick: () =>
                                          _vm.makeBackPhoneCall(record),
                                        className:
                                          "btn btn-success btn-xs missed_phoneCall_btn",
                                      },
                                    }),
                                  ]
                                : [
                                    _c("MakePhoneCall", {
                                      attrs: {
                                        recordId: record.id,
                                        onCall: _vm.updateRecords,
                                      },
                                    }),
                                  ],
                            ],
                            2
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Пропущенные звонки и запросы на обратный звонок")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Кто звонил")]),
        _vm._v(" "),
        _c("th", [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", [_vm._v("Куда звонил")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "min-width": "250px" } }, [
          _vm._v("Прозвоны"),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("всплывашка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i", { staticClass: "icon-fa icon-fa-warning color-red" }),
      _vm._v(" "),
      _c("strong", [_vm._v("Черный список")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i", { staticClass: "icon-fa icon-fa-warning color-red" }),
      _vm._v(" "),
      _c("strong", [_vm._v("Черный список")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }